/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ELogBusinessEventName, ELogBusinessEventType, logBusinessEvent } from '../../../../modules/logging';
import { makeSelectGuardComponents } from '../../../../modules/role';
import { ITableLinkProps } from '../../../../modules/table';
import { openExternalRoute } from '../../../../routes/constants/externalRoutes';
import { getPageInquiryInfoUrl, isPageInquiryInfoExternalUrl } from '../../../PageInquiryInfo';

export const useTableOrderCellAction = (id: string, branch?: string): ITableLinkProps => {
    const dispatch = useDispatch();
    const componentsFeature = useSelector(makeSelectGuardComponents());

    const onClick = useCallback(() => {
        dispatch(logBusinessEvent({
            eventName: ELogBusinessEventName.USER_SHOW_INQUIRY_INFO,
            type: ELogBusinessEventType.common,
        }));
        if (isPageInquiryInfoExternalUrl(componentsFeature)) {
            openExternalRoute(getPageInquiryInfoUrl(componentsFeature, id, branch));
        }
    }, [dispatch, componentsFeature, id, branch]);

    return {
        isExternalUrl: isPageInquiryInfoExternalUrl(componentsFeature),
        url: getPageInquiryInfoUrl(componentsFeature, id, branch),
        onClick,
        children: id,

        noValue: !id,
    };
};
